import { useTranslation } from 'react-i18next'
import { RouteComponentProps } from 'react-router-dom'
import { IonContent, IonIcon, IonLabel, IonPage } from '@ionic/react'
import cx from 'classnames'
import { chevronForward } from 'ionicons/icons'

import { LogoPWA } from '@/components/atoms/assets/LogoPWA'

import { usePromptToInstall } from '@/lib/promptToInstallProvider'
import { Routes } from '@/router/routes'

import { BasicPwaOnboarding } from './BasicPwaOnboarding'
import { PWAInstallerPrompt } from './PWAInstallerPrompt'

export const PwaOnboarding = ({ history }: RouteComponentProps) => {
  const { t } = useTranslation('common')

  const handleContinue = () => {
    history.push(Routes.FEED)
  }

  const { pwaBeforeInstallPromptEvent } = usePromptToInstall()

  const isSupportInstallPrompt =
    'BeforeInstallPromptEvent' in window && pwaBeforeInstallPromptEvent

  return (
    <IonPage>
      <IonContent fullscreen>
        <div className="w-full h-[100dvh] flex items-center flex-col grow overflow-y-scroll mx-auto pt-28 px-8 text-white">
          <div className="grid min-w-min min-h-min">
            <LogoPWA />
          </div>
          <div className="grid">
            <IonLabel
              className={cx(
                'grid pt-16 text-base font-normal',
                isSupportInstallPrompt ? 'text-center' : 'text-left'
              )}
            >
              {t('PWAOnboarding.title')}
            </IonLabel>
            {isSupportInstallPrompt ? (
              <PWAInstallerPrompt />
            ) : (
              <BasicPwaOnboarding />
            )}
            <div onClick={handleContinue} className="grid mb-8">
              <IonLabel className="font-normal">
                {t('PWAOnboarding.youCanAlso')}
              </IonLabel>
              <div>
                <IonLabel className="mt-1.5 font-bold">
                  {t('PWAOnboarding.continueBrowser')}
                </IonLabel>
                <IonIcon
                  className="ml-1 align-middle text-sm"
                  icon={chevronForward}
                />
              </div>
            </div>
          </div>
        </div>
      </IonContent>
    </IonPage>
  )
}
